import axiosInstance from './axiosInstance'; // Import your axios instance

const userService = {
  // Fetch all users
  getUsers: async () => {
    try {
      const response = await axiosInstance.get('/users');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add a new user
  addUser: async (userData) => {
    try {
      console.log(userData)
      const response = await axiosInstance.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('خطأ في API:', error.response.data);
        throw new Error(error.response.data.message || 'فشل في إضافة المستخدم.');
      } else {
        console.error('خطأ غير متوقع:', error.message);
        throw new Error('حدث خطأ غير متوقع أثناء إضافة المستخدم.');
      }
    }
  },
  
  updateUser: async (userId, updatedData) => {
    try {
      const response = await axiosInstance.put(`/users/${userId}`, updatedData);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('خطأ في API:', error.response.data);
        throw new Error(error.response.data.message || 'فشل في تحديث المستخدم.');
      } else {
        console.error('خطأ غير متوقع:', error.message);
        throw new Error('حدث خطأ غير متوقع أثناء تحديث المستخدم.');
      }
    }
  },

  // Delete a user
  deleteUser: async (userId) => {
    try {
      const response = await axiosInstance.delete(`/users/user/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default userService;


